import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'antd';
import useCloseOnScroll from '../../../../hooks/useCloseOnScroll';

import { PRIORITY_COLORS, PRIORITY_LABEL, taskPriority, PRIORITY_ICON } from '../../../../js/constants';
import { FormattedMessage } from 'react-intl';
import { editTaskAction } from '../../../../redux/tasks/actions';

const PriorityDropdown = (props) => {
  const { task, onClick, small, isTask } = props;
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const triggerRef = useRef(null);

  useCloseOnScroll(dropdownOpen, triggerRef, () => setDropdownOpen(false));

  const onChange = (priority) => {
    if (task?.priority !== priority.rank) {
      task.priority = priority.rank;
      dispatch(editTaskAction({
        _id: task?._id,
        taskTitle: task?.taskTitle,
        priority: priority.rank,
      }));
    }
  }

  return (
    <div ref={triggerRef}>
    <Dropdown
      overlayStyle={{
        padding: 10
      }}
      arrow={false}
      trigger={['click']}
      open={dropdownOpen}
      onOpenChange={setDropdownOpen}
      menu={{
        items:
          taskPriority.map((priority, i) => {
            const html =
              <div
                className={`priority-pill ${priority?.rank === 'nill' ? 'flex items-center justify-center' : 'flex items-center gap-2 px-3'} px-3 text-xs ${small ? 'w-full' : 'w-24'}  ${i == 0 && 'text-slate-700'}`}>
                {PRIORITY_ICON[priority?.rank] && !small && (
                  <img
                    src={`/images/icons/${PRIORITY_ICON[priority?.rank]}.svg`}
                    alt={priority?.name}
                    className="size-3 mr-1"
                  />
                )}
                <span style={{ color: PRIORITY_COLORS[priority?.rank] }}> <FormattedMessage id={priority?.name?.toUpperCase() || "--"} defaultMessage={priority?.name || "--"} /> </span>
              </div>
            return ({
              key: priority?.rank,
              label: html,
              onClick: () => onClick ? onClick(priority) : onChange(priority)
            })
          })
      }}
      placement='bottom'
    >
      {isTask ?
        <div className='flex align-center justify-between text-center py-2 px-5'>
          <div className='font-14 truncate text-center capitalize rounded-xl'
            style={{ background: PRIORITY_COLORS[task?.priority] }}>
            {task?.priority && task?.priority !== 'nill' ?
              <div className='flex align-center justify-center w-[100px] px-2'>
                {PRIORITY_ICON[task?.priority] && (
                  <img
                    src={`/images/icons/${PRIORITY_ICON[task?.priority]}.svg`}
                    alt={task?.priority}
                    className="size-3 mr-1"
                  />
                )}
                <div className={`${small ? 'font-12 text-white' : 'font-14'} `}>
                  <FormattedMessage id={PRIORITY_LABEL[task?.priority]?.toUpperCase() || task?.priority || '--'} defaultMessage={PRIORITY_LABEL[task?.priority] || task?.priority || '--'} />
                </div>
              </div> :
              <div className='font-14 cursor-pointer text-center'>
                Select
              </div>}
          </div>
        </div>
        : <div
          className={`hover:opacity-90 cursor-pointer flex align-center justify-center gap-1 ${small ? 'h-5 border-radius10 py-1 px-4 flex align-center justify-center' : 'priority-pill w-24'}`}
          style={{ background: PRIORITY_COLORS[task?.priority] }}>
          {task?.priority && task?.priority !== 'nill' ?
            <>
              {PRIORITY_ICON[task?.priority] && (
                <img
                  src={`/images/icons/${PRIORITY_ICON[task?.priority]}.svg`}
                  alt={task?.priority}
                  className="size-3 mr-1"
                  style={{ filter: "brightness(0) invert(1)" }}
                />
              )}
              <div className={`${small ? 'font-12 text-white' : 'font-14'} `}>
                <FormattedMessage id={PRIORITY_LABEL[task?.priority]?.toUpperCase() || task?.priority || '--'} defaultMessage={PRIORITY_LABEL[task?.priority] || task?.priority || '--'} />
              </div>
            </> :
            <div className='font-16 bg-slate-100 border-radius10 text-slate-500 w-10 cursor-pointer text-center'>
              --
            </div>}
        </div>}
    </Dropdown>
    </div>
  );
};

export default PriorityDropdown;
